import { apiService } from './api';
import { Skill } from '../types/skill';
import { AxiosResponse } from 'axios';

export const skillService = {
    getAllSkills(): Promise<AxiosResponse<Skill[]>> {
        return apiService.get<Skill[]>('/Skill');
    },
};
